module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/danaspirit-avatar-199b13908ff9671207ffe532cd4bcdb7.jpg";